import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ReviewNoteMutationVariables = Types.Exact<{
  input: Types.ReviewNoteInput;
}>;


export type ReviewNoteMutation = { reviewNote: { success?: boolean | null } };


export const ReviewNoteDocument = /*#__PURE__*/ gql`
    mutation ReviewNote($input: ReviewNoteInput!) {
  reviewNote(input: $input) {
    success
  }
}
    `;

export function useReviewNoteMutation() {
  return Urql.useMutation<ReviewNoteMutation, ReviewNoteMutationVariables>(ReviewNoteDocument);
};